import { render, staticRenderFns } from "./GeneralJournalForm.vue?vue&type=template&id=0e88bfd2"
import script from "./GeneralJournalForm.vue?vue&type=script&lang=js"
export * from "./GeneralJournalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports